import { render, staticRenderFns } from "./sxtfbt.vue?vue&type=template&id=0d6309a1"
import script from "./sxtfbt.vue?vue&type=script&lang=js"
export * from "./sxtfbt.vue?vue&type=script&lang=js"
import style0 from "./sxtfbt.vue?vue&type=style&index=0&id=0d6309a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports